import { EdgeComputingCourse } from './types';

export const EDGE_COMPUTING_COURSES: EdgeComputingCourse[] = [
  {
    id: 'edge-computing-cdn-optimization',
    title: 'Edge Computing & CDN Optimization',
    description: 'Master edge computing principles and CDN optimization strategies for global content delivery.',
    level: 'intermediate',
    totalDuration: '6 hours',
    image: '/api/placeholder/400/300',
    tags: ['Edge Computing', 'CDN', 'Performance', 'Global Distribution', 'Caching'],
    prerequisites: ['Web development basics', 'HTTP/HTTPS understanding', 'Basic networking'],
    estimatedHours: 6,
    objectives: [
      'Understand edge computing architecture',
      'Optimize content delivery networks',
      'Implement edge caching strategies',
      'Reduce latency for global users'
    ],
    learningOutcomes: [
      'Design edge computing architectures',
      'Configure CDN for optimal performance',
      'Implement advanced caching strategies',
      'Optimize content for edge delivery',
      'Monitor and analyze edge performance',
      'Reduce global latency and improve UX'
    ],
    modules: [
      {
        id: 'edge-computing-fundamentals',
        title: 'Edge Computing Fundamentals',
        description: 'Learn core concepts of edge computing',
        content: 'Edge computing brings computation and data storage closer to users...',
        duration: '1.5 hours',
        difficulty: 'beginner',
        order: 1,
        estimatedTime: '1.5 hours',
        learningObjectives: [
          'Understand edge vs. cloud computing',
          'Learn edge computing use cases',
          'Explore edge infrastructure components'
        ],
        codeExamples: [
          {
            title: 'Edge Function Example',
            code: 'export default {\n  async fetch(request) {\n    const url = new URL(request.url);\n    if (url.pathname === "/api/location") {\n      return new Response(JSON.stringify({\n        country: request.cf.country,\n        city: request.cf.city\n      }));\n    }\n    return fetch(request);\n  }\n}',
            explanation: 'A simple edge function that returns user location data.',
            language: 'javascript'
          }
        ]
      },
      {
        id: 'cdn-architecture',
        title: 'CDN Architecture and Configuration',
        description: 'Design and configure content delivery networks',
        content: 'Learn how CDNs work and how to configure them effectively...',
        duration: '2 hours',
        difficulty: 'intermediate',
        order: 2
      },
      {
        id: 'edge-caching-strategies',
        title: 'Edge Caching Strategies',
        description: 'Implement advanced caching at the edge',
        content: 'Master different caching strategies for various content types...',
        duration: '1.5 hours',
        difficulty: 'intermediate',
        order: 3
      },
      {
        id: 'edge-security',
        title: 'Edge Security and DDoS Protection',
        description: 'Secure applications at the edge',
        content: 'Implement security measures and DDoS protection at edge locations...',
        duration: '1 hour',
        difficulty: 'advanced',
        order: 4
      }
    ],
    type: 'edge-computing'
  },
  {
    id: 'serverless-edge-functions',
    title: 'Serverless Edge Functions (Cloudflare Workers, Vercel)',
    description: 'Build and deploy serverless functions at the edge using Cloudflare Workers and Vercel Edge Functions.',
    level: 'intermediate',
    totalDuration: '8 hours',
    image: '/api/placeholder/400/300',
    tags: ['Serverless', 'Edge Functions', 'Cloudflare Workers', 'Vercel', 'Performance'],
    prerequisites: ['JavaScript/TypeScript', 'API development', 'Serverless concepts'],
    estimatedHours: 8,
    objectives: [
      'Build serverless functions at the edge',
      'Deploy with Cloudflare Workers and Vercel',
      'Optimize edge function performance',
      'Implement edge-side authentication'
    ],
    learningOutcomes: [
      'Create edge functions with modern APIs',
      'Deploy to multiple edge platforms',
      'Handle requests at edge locations',
      'Implement edge-side A/B testing',
      'Optimize cold start performance',
      'Monitor edge function metrics'
    ],
    modules: [
      {
        id: 'cloudflare-workers-basics',
        title: 'Cloudflare Workers Fundamentals',
        description: 'Get started with Cloudflare Workers',
        content: 'Cloudflare Workers run JavaScript at the edge across 200+ cities...',
        duration: '2 hours',
        difficulty: 'intermediate',
        order: 1
      },
      {
        id: 'vercel-edge-functions',
        title: 'Vercel Edge Functions',
        description: 'Build edge functions with Vercel',
        content: 'Learn Vercel\'s edge runtime and deployment model...',
        duration: '2 hours',
        difficulty: 'intermediate',
        order: 2
      },
      {
        id: 'edge-apis-databases',
        title: 'Edge APIs and Databases',
        description: 'Connect edge functions to databases',
        content: 'Learn to work with edge-compatible databases and APIs...',
        duration: '2 hours',
        difficulty: 'advanced',
        order: 3
      },
      {
        id: 'edge-authentication',
        title: 'Edge Authentication and Security',
        description: 'Implement authentication at the edge',
        content: 'Secure edge functions with JWT, OAuth, and custom auth...',
        duration: '1 hour',
        difficulty: 'advanced',
        order: 4
      },
      {
        id: 'edge-monitoring',
        title: 'Edge Function Monitoring',
        description: 'Monitor and debug edge functions',
        content: 'Set up monitoring, logging, and debugging for edge functions...',
        duration: '1 hour',
        difficulty: 'intermediate',
        order: 5
      }
    ],
    type: 'edge-computing'
  }
];